<template>
<div>
  <div class="row justify-content-center">
    <br>
    <img class="img-responsive" src="https://taxi-fiable-public.s3.amazonaws.com/dev/imagenes/banner.png" alt=""
      width="40%" height="auto">
  </div>
  <br>
  <br>
  <div class="text-center" v-if="loading">
     <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
  </div>
  <br>
  <h2>No cierres esta ventana, estamos procesando la información</h2>
  </div>
</template>
<script>
// import { encrypt } from '@/config/headers'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import config from '../../../environmentConfig.json'
const GET_SETUP_CARDINAL = gql`
  query getSetupCardinal($rfc: String, $setupCardinal: Boolean){
    getSetupCardinal(rfc: $rfc, setupCardinal: $setupCardinal){
      paidBy
      paymentDate
      createdAt
      pk
      type
      paymentURL
      transaction {
        card_type_name
        req_card_number
      }
      idTransaction
      concesiones{
        concesionNumber
        periodos
        vehicle {
          brand
          licensePlate
          model
        }
        amount
      }
      amount
      successful
      status
      jti
      jwt
      body
      sCardinal
    }
  }
`
const GET_CONCESIONARIO_BY_ID = gql`
  query getConcesionarioId($id: Int) {
    getConcesionarioId(id: $id){
      id
      name
      automaticPayment
      cardId
      address {
        state
        city
        postalCode
        street
        suburb
        extNumber
        intNumber
      }
    }
  }
`
export default {
  data() {
    return {
      concesionario: {},
      totalRows: 1,
      loading: false,
    }
  },
  mounted() {
    console.log('ENTRA EN mounted')
    this.loading = true
    this.$apollo.query({
      query: GET_CONCESIONARIO_BY_ID,
      context: headers(),
      variables: {
        id: parseInt(this.$store.state.user.franchisee),
      },
    })
      .then(({ data }) => {
        this.concesionario = data.getConcesionarioId
      })
      .catch(e => {
        console.log(e)
      })
    this.queryPaymentsHistory()
  },
  methods: {
    queryPaymentsHistory() {
      console.log('ENTRA EN queryPaymentsHistory')
      this.$apollo.query({
        query: GET_SETUP_CARDINAL,
        context: headers(),
        variables: {
          rfc: this.$store.state.user.rfc,
          setupCardinal: true,
        },
      }).then(({ data }) => {
        console.log(data)
        if (data.getSetupCardinal) {
          console.log('Entra en if')
          this.getSetupCardinal = data.getSetupCardinal.sort((a, b) => {
            // console.log(new Date(a.createdAt), new Date(b.createdAt))
            return new Date(b.createdAt) - new Date(a.createdAt)
          })
          this.getSetupCardinal = data.getSetupCardinal
          console.log(this.getSetupCardinal)
          if (this.getSetupCardinal[0]['sCardinal']) {
            this.totalRows = data.getSetupCardinal.length
            const trx = data.getSetupCardinal[0].idTransaction
            setTimeout(() => this.authorizeRedirect(this.$store.state.user.rfc, trx), 3000)
          } else {
            console.log('sCardinal es false')
            this.$router.push({ name: 'listPaymentsRent' })
          }
        } else {
          console.log('Entra en listPaymentsRent')
          this.$router.push({ name: 'listPaymentsRent' })
        }
      }).catch(err => {
        console.log('catch error')
        console.log(err)
        if (err) {
          console.log('Entra en catch')
          this.$router.push({ name: 'listPaymentsRent' })
        }
      })
    },
    authorizeRedirect(rfc, idTransaction) {
      console.log('Entra en authorizeRedirect', rfc, ' ', idTransaction)
      const authorizeUrl = `${config[process.env.NODE_ENV].securePayment}cardinaljwt/${rfc}/${idTransaction}`
      console.log(authorizeUrl)
      window.location.href = authorizeUrl
    },
  },
}
</script>
<style>
</style>
